import { render, staticRenderFns } from "./AdminSettingsMenu.vue?vue&type=template&id=939cc5a2&scoped=true&"
import script from "./AdminSettingsMenu.vue?vue&type=script&lang=js&"
export * from "./AdminSettingsMenu.vue?vue&type=script&lang=js&"
import style0 from "./AdminSettingsMenu.vue?vue&type=style&index=0&id=939cc5a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "939cc5a2",
  null
  
)

export default component.exports